import { combineReducers } from "redux";

// Import reducers as they are created
// import mediaReducer from "./mediaReducer";
import startupReducer from "./startupReducer";
import libraryCardReducer from "./libraryCardReducer";
import videoSubmissionReducer from "./videoSubmissionReducer";
import contentComposerReducer from "./contentComposerReducer";
import videoRenderReducer from "./videoRenderReducer";
import publicationScheduleReducer from "./publicationScheduleReducer";
import contentFeedReducer from "./contentFeedReducer";

const rootReducer = combineReducers({
  // media: mediaReducer,
  startup: startupReducer,
  libraryCards: libraryCardReducer,
  videoSubmission: videoSubmissionReducer,
  contentComposer: contentComposerReducer,
  videoRender: videoRenderReducer,
  publicationSchedule: publicationScheduleReducer,
  contentFeed: contentFeedReducer,
  // Add more reducers as needed
});

export default rootReducer;
